import styled from 'styled-components';
const getColor = ({ $appearance, $isOpen, theme }) => {
    var _a, _b;
    if ($appearance === 'primary') {
        return $isOpen
            ? 'var(--text-primary)'
            : ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnBackground) || 'var(--text-primary)';
    }
    if ($appearance === 'secondary') {
        return 'var(--text-secondary)';
    }
};
export const TooltipContainer = styled.div `
  color: ${getColor};
  cursor: pointer;

  &:hover {
    color: var(--text-brand);
  }
`;
//# sourceMappingURL=styled.js.map